//import phUser from '../images/svg/ph-user.svg';

import { i18n } from '../custom/translator';

//import phUser from 'url:../images/svg/ph-user.svg';
const phUser = new URL('../images/svg/ph-user.svg', import.meta.url);
let cookieFbLang = 'firebase-language-override';

export function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function saveCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function deleteCookie(cname) {
  //document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
  document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

export function initLangCookie() {
  var lang = getCookie(cookieFbLang);

  if (lang != '') {
    deleteCookie(cookieFbLang);
    //saveCookie(cookieFbLang, lang, 365);
    // $(`input[name=lang][value=${lang}]`).prop("checked", true);
    // var lbl = document.querySelector(`label.${lang}`);
    // $(`#btnTranslate span`).text(lbl.textContent);
  }
  return lang || 'en';
}

export function initLangAction() {
  $('.dropdown-content a').click(function (event) {
    deleteCookie(cookieFbLang);
    //saveCookie(cookieFbLang, this.title, 365);
    //alert("An external link was clicked!");
    location.reload();
    event.preventDefault();
  });

  //   var btnTrans = document.getElementById("btnTranslate");

  //   var listRads = document.querySelectorAll(".drop-content input");
  //   for (let index = 0; index < listRads.length; index++) {
  //     const rad = listRads[index];
  //     rad.addEventListener("click", function () {
  //       var cvalue = rad.value;
  //       saveCookie(cookieFbLang, cvalue, 365);
  //       var lbl = document.querySelector(`label.${cvalue}`);
  //       $(`#btnTranslate span`).text(lbl.textContent);
  //       // var web = `../localized-files/${cvalue}/index.html`;
  //       // window.location.replace(web);
  //       location.reload();
  //     });
  //   }
}

export function initFooter() {
  var d = new Date();
  var smYear = document.getElementById('smYear');
  if (smYear) {
    smYear.textContent = smYear.textContent.replace('$year', d.getFullYear());
  }
}

export function initResponsivecMenu() {
  console.log('started header');
  var aToggle = document.getElementById('aToggle');
  var dMenu = document.querySelector('.header-menu .collapse');
  if (aToggle === null || dMenu === null) {
    return;
  } else {
    console.log("header won't click: ");
  }
  console.log('header will click: ');

  aToggle.addEventListener('click', toggleMenu);
  document.body.addEventListener('click', function (event) {
    // Check if the clicked element is NOT the div itself and NOT a child of the div
    if (!aToggle.contains(event.target) && event.target !== aToggle) {
      dMenu.style.display = 'none'; // Hide the div
    }
  });
  document
    .querySelector('.nav-dropdown')
    .addEventListener('click', function (event) {
      // Stops the click from bubbling up and triggering close actions
      event.stopPropagation();
    });
}

function toggleMenu() {
  var x = document.querySelector('.header-menu .collapse');
  console.log('header clicked: ', x.style.display);

  if (x === null) return;
  if (x.style.display === 'flex') {
    x.style.display = 'none';
  } else {
    x.style.display = 'flex';
  }
}

export function addDonateInfo() {
  let link = `zeffy-form-link="https://www.zeffy.com/embed/donation-form/donate-to-change-lives-6222?modal=true"`;
}

export const role = [
  'Founder & CEO',
  'Ambassador',
  'Director/Official of Communications',
  'Programs & Services',
  'Fundraising & Development',
  'Marketing & Communications',
  'Administrations & Operations',
];

export const roleEs = [
  'Fundador y CEO',
  'Embajador',
  'Director/Oficial de Comunicaciones',
  'Programas y Servicios',
  'Recaudación de fondos y Desarrollo',
  'Marketing y Comunicaciones',
  'Administración y operaciones',
];

export const countryEsList = [
  'Afganistán',
  'Albania',
  'Argelia',
  'Samoa Americana',
  'Andorra',
  'Angola',
  'Anguila',
  'Antártida',
  'Antigua y Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaiyán',
  'Bahamas',
  'Bahréin',
  'Bangladesh',
  'Barbados',
  'Bielorrusia',
  'Bélgica',
  'Belice',
  'Benin',
  'Islas Bermudas',
  'Bután',
  'Bolivia (Estado Plurinacional de)',
  'Bonaire, Sint Eustatius y Saba',
  'Bosnia y Herzegovina',
  'Botswana',
  'Isla Bouvet',
  'Brasil',
  'Territorio Británico del Océano Índico',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Camboya',
  'Camerún',
  'Canadá',
  'Islas Caimán',
  'República Centroafricana',
  'Chad',
  'Chile',
  'Porcelana',
  'Isla de Navidad',
  'Islas Cocos (Keeling)',
  'Colombia',
  'Comoras',
  'Congo (República Democrática del)',
  'Congo',
  'Islas Cook',
  'Costa Rica',
  'Croacia',
  'Cuba',
  'Curazao',
  'Chipre',
  'Chequia',
  "Côte d'Ivoire",
  'Dinamarca',
  'Djibouti',
  'Dominica',
  'República Dominicana',
  'Ecuador',
  'Egipto',
  'El Salvador',
  'Guinea Ecuatorial',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Etiopía',
  'Islas Falkland [Malvinas]',
  'Islas Faroe',
  'Fiji',
  'Finlandia',
  'Francia',
  'Guayana Francesa',
  'Polinesia francés',
  'Territorios Franceses del Sur',
  'Gabón',
  'Gambia',
  'Georgia',
  'Alemania',
  'Ghana',
  'Gibraltar',
  'Grecia',
  'Groenlandia',
  'Granada',
  'Guadalupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guayana',
  'Haití',
  'Islas Heard y McDonald',
  'Santa Sede',
  'Honduras',
  'Hong Kong',
  'Hungría',
  'Islandia',
  'India',
  'Indonesia',
  'Irán (República Islámica de)',
  'Irak',
  'Irlanda',
  'Isla del hombre',
  'Israel',
  'Italia',
  'Jamaica',
  'Japón',
  'Suéter',
  'Jordán',
  'Kazajstán',
  'Kenia',
  'Kiribati',
  'Corea (República Popular Democrática de)',
  'Corea (República de)',
  'Kuwait',
  'Kirguistán',
  'República Democrática Popular Lao',
  'Letonia',
  'Líbano',
  'Lesoto',
  'Liberia',
  'Libia',
  'Liechtenstein',
  'Lituania',
  'Luxemburgo',
  'Macao',
  'Madagascar',
  'Malawi',
  'Malasia',
  'Maldivas',
  'Malí',
  'Malta',
  'Islas Marshall',
  'Martinica',
  'Mauritania',
  'Mauricio',
  'Mayotte',
  'México',
  'Micronesia (Estados Federados de)',
  'Moldova (la República de)',
  'Mónaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Marruecos',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Países Bajos',
  'Nueva Caledonia',
  'Nueva Zelanda',
  'Nicaragua',
  'Níger',
  'Nigeria',
  'Niue',
  'Isla Norfolk',
  'Islas Marianas del Norte',
  'Noruega',
  'Omán',
  'Pakistán',
  'Palau',
  'Palestina, Estado de',
  'Panamá',
  'Papúa Nueva Guinea',
  'Paraguay',
  'Perú',
  'Filipinas',
  'Pitcairn',
  'Polonia',
  'Portugal',
  'Puerto Rico',
  'Katar',
  'República de Macedonia del Norte',
  'Rumania',
  'Federación Rusa',
  'Ruanda',
  'Cita',
  'San Bartolomé',
  'Santa Elena, Ascensión y Tristan da Cunha',
  'Saint Kitts y Nevis',
  'Santa Lucía',
  'San Martín (parte francesa)',
  'San Pedro y Miquelón',
  'San Vicente y las Granadinas',
  'Samoa',
  'San Marino',
  'Santo Tomé y Príncipe',
  'Arabia Saudita',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leona',
  'Singapur',
  'Sint Maarten (parte holandesa)',
  'Eslovaquia',
  'Eslovenia',
  'Islas Salomón',
  'Somalia',
  'Sudáfrica',
  'Georgia del sur y las islas Sandwich del sur',
  'Sudán del Sur',
  'España',
  'Sri Lanka',
  'Sudán',
  'Surinam',
  'Svalbard y Jan Mayen',
  'Suecia',
  'Suiza',
  'República Árabe Siria',
  'Taiwán',
  'Tayikistán',
  'República Unida de Tanzanía',
  'Tailandia',
  'Timor-Leste',
  'Ir',
  'Tokelau',
  'Tonga',
  'Trinidad y Tobago',
  'Túnez',
  'Pavo',
  'Turkmenistán',
  'Islas Turcas y Caicos',
  'Tuvalu',
  'Uganda',
  'Ucrania',
  'Emiratos Árabes Unidos',
  'Reino Unido de Gran Bretaña e Irlanda del Norte',
  'Islas menores alejadas de los Estados Unidos',
  'Estados Unidos',
  'Uruguay',
  'Uzbekistán',
  'Vanuatu',
  'Venezuela (República Bolivariana de)',
  'Vietnam',
  'Islas Vírgenes (Británicas)',
  'Islas Vírgenes (EE. UU.)',
  'Wallis y Futuna',
  'Sahara Occidental',
  'Yemen',
  'Zambia',
  'Zimbabue',
  'Islas Aland',
];
export const countryList = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia (Plurinational State of)',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo (the Democratic Republic of the)',
  'Congo',
  'Cook Islands',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czechia',
  "Côte d'Ivoire",
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Falkland Islands [Malvinas]',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran (Islamic Republic of)',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea (the Democratic People's Republic of)",
  'Korea (the Republic of)',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic Republic",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia (Federated States of)',
  'Moldova (the Republic of)',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine, State of',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Republic of North Macedonia',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Réunion',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom of Great Britain and Northern Ireland',
  'United States Minor Outlying Islands',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela (Bolivarian Republic of)',
  'Viet Nam',
  'Virgin Islands (British)',
  'Virgin Islands (U.S.)',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
  'Åland Islands',
];

export const countryCodeList = [
  'AF',
  'AL',
  'DZ',
  'AS',
  'AD',
  'AO',
  'AI',
  'AQ',
  'AG',
  'AR',
  'AM',
  'AW',
  'AU',
  'AT',
  'AZ',
  'BS',
  'BH',
  'BD',
  'BB',
  'BY',
  'BE',
  'BZ',
  'BJ',
  'BM',
  'BT',
  'BO',
  'BQ',
  'BA',
  'BW',
  'BV',
  'BR',
  'IO',
  'BN',
  'BG',
  'BF',
  'BI',
  'CV',
  'KH',
  'CM',
  'CA',
  'KY',
  'CF',
  'TD',
  'CL',
  'CN',
  'CX',
  'CC',
  'CO',
  'KM',
  'CD',
  'CG',
  'CK',
  'CR',
  'HR',
  'CU',
  'CW',
  'CY',
  'CZ',
  'CI',
  'DK',
  'DJ',
  'DM',
  'DO',
  'EC',
  'EG',
  'SV',
  'GQ',
  'ER',
  'EE',
  'SZ',
  'ET',
  'FK',
  'FO',
  'FJ',
  'FI',
  'FR',
  'GF',
  'PF',
  'TF',
  'GA',
  'GM',
  'GE',
  'DE',
  'GH',
  'GI',
  'GR',
  'GL',
  'GD',
  'GP',
  'GU',
  'GT',
  'GG',
  'GN',
  'GW',
  'GY',
  'HT',
  'HM',
  'VA',
  'HN',
  'HK',
  'HU',
  'IS',
  'IN',
  'ID',
  'IR',
  'IQ',
  'IE',
  'IM',
  'IL',
  'IT',
  'JM',
  'JP',
  'JE',
  'JO',
  'KZ',
  'KE',
  'KI',
  'KP',
  'KR',
  'KW',
  'KG',
  'LA',
  'LV',
  'LB',
  'LS',
  'LR',
  'LY',
  'LI',
  'LT',
  'LU',
  'MO',
  'MG',
  'MW',
  'MY',
  'MV',
  'ML',
  'MT',
  'MH',
  'MQ',
  'MR',
  'MU',
  'YT',
  'MX',
  'FM',
  'MD',
  'MC',
  'MN',
  'ME',
  'MS',
  'MA',
  'MZ',
  'MM',
  'NA',
  'NR',
  'NP',
  'NL',
  'NC',
  'NZ',
  'NI',
  'NE',
  'NG',
  'NU',
  'NF',
  'MP',
  'NO',
  'OM',
  'PK',
  'PW',
  'PS',
  'PA',
  'PG',
  'PY',
  'PE',
  'PH',
  'PN',
  'PL',
  'PT',
  'PR',
  'QA',
  'MK',
  'RO',
  'RU',
  'RW',
  'RE',
  'BL',
  'SH',
  'KN',
  'LC',
  'MF',
  'PM',
  'VC',
  'WS',
  'SM',
  'ST',
  'SA',
  'SN',
  'RS',
  'SC',
  'SL',
  'SG',
  'SX',
  'SK',
  'SI',
  'SB',
  'SO',
  'ZA',
  'GS',
  'SS',
  'ES',
  'LK',
  'SD',
  'SR',
  'SJ',
  'SE',
  'CH',
  'SY',
  'TW',
  'TJ',
  'TZ',
  'TH',
  'TL',
  'TG',
  'TK',
  'TO',
  'TT',
  'TN',
  'TR',
  'TM',
  'TC',
  'TV',
  'UG',
  'UA',
  'AE',
  'GB',
  'UM',
  'US',
  'UY',
  'UZ',
  'VU',
  'VE',
  'VN',
  'VG',
  'VI',
  'WF',
  'EH',
  'YE',
  'ZM',
  'ZW',
  'AX',
];

//add other languages using
//https://www.html-code-generator.com/javascript/array/languages-name
export const languages = [
  { name: 'Afrikaans', code: 'af', native: 'Afrikaans' },
  { name: 'Arabic', code: 'ar', native: 'العربية' },
  { name: 'Bengali', code: 'bn', native: 'বাংলা' },
  { name: 'Chinese', code: 'zh', native: '中文' },
  { name: 'English', code: 'en', native: 'English' },
  { name: 'Filipino', code: 'fil', native: 'Filipino' },
  { name: 'Finnish', code: 'fi', native: 'suomi' },
  { name: 'French', code: 'fr', native: 'français' },
  { name: 'German', code: 'de', native: 'Deutsch' },
  { name: 'Greek', code: 'el', native: 'Ελληνικά' },
  { name: 'Hindi', code: 'hi', native: 'हिन्दी' },
  { name: 'Hungarian', code: 'hu', native: 'magyar' },
  { name: 'Icelandic', code: 'is', native: 'íslenska' },
  { name: 'Indonesian', code: 'id', native: 'Indonesia' },
  { name: 'Italian', code: 'it', native: 'italiano' },
  { name: 'Japanese', code: 'ja', native: '日本語' },
  { name: 'Korean', code: 'ko', native: '한국어' },
  { name: 'Polish', code: 'pl', native: 'polski' },
  { name: 'Portuguese', code: 'pt', native: 'português' },
  { name: 'Punjabi', code: 'pa', native: 'ਪੰਜਾਬੀ' },
  { name: 'Russian', code: 'ru', native: 'русский' },
  { name: 'Spanish', code: 'es', native: 'español' },
  { name: 'Swedish', code: 'sv', native: 'svenska' },
  { name: 'Turkish', code: 'tr', native: 'Türkçe' },
  { name: 'Ukrainian', code: 'uk', native: 'українська' },
  { name: 'Vietnamese', code: 'vi', native: 'Tiếng Việt' },
  { name: 'Welsh', code: 'cy', native: 'Cymraeg' },
];

export var userInfo = {
  name: null,
  id: null, //auto generated
  email: null,
  img: null,
  imgUrl: null,
  date: null, //auto generated
  role: null,
  desc: null,
  lang: null,
  country: null,
  enDesc: null, //after revision
  roleLocale: null,
  un: null, //for username
  dob: null, //date of birth
};

export var roleInfo = {
  uid: null,
  name: null,
  role: null,
  date: null,
  desc: null,
  enDesc: null,
  roleLocale: null,
  banner: null,
  status: null,
  note: null,
  adminId: null,
  dt: null, //decision date
};

export const roles = [
  {
    id: 'radCeo',
    title: 'Founder & CEO',
    value: 'ceo',
    info: "Work closely with the Board of Trustees, donors, stakeholders, and the public to ensure the nonprofit's financial sustainability and fulfill its mission.",
  },
  {
    id: 'radAmb',
    title: 'Ambassador',
    value: 'amb',
    info: "A representative who helps the non-profit expand its reach by using personal networks, fundraising, and volunteering to support the charity's goal.",
  },
  {
    id: 'radCom',
    title: 'Director/Official of Communications',
    value: 'com',
    info: 'Build awareness and engagement through marketing and on social media.',
  },
  {
    id: 'radProg',
    title: 'Program Manager/Coordinator',
    value: 'prog',
    info: "Develop and execute program strategies and daily operations to deliver the non-profit's core mission.",
  },
  {
    id: 'radFund',
    title: 'Fundraising Coordinator',
    value: 'fund',
    info: "Secure resources necessary to carry out the non-profit's mission.",
  },
  {
    id: 'radVol',
    title: 'Volunteer',
    value: 'vol',
    info: 'Help charity projects by organizing or assisting at the events in support of its mission',
  },
];

export const rolesEs = [
  {
    id: 'radCeo',
    title: 'Fundador y CEO',
    value: 'ceo',
    info: 'Trabajar en estrecha colaboración con la Junta Directiva, los donantes, las partes interesadas y el público para garantizar la sostenibilidad financiera de la organización sin fines de lucro y cumplir su misión.',
  },
  {
    id: 'radAmb',
    title: 'Embajador',
    value: 'amb',
    info: 'Un representante que ayuda a la organización sin fines de lucro a ampliar su alcance mediante el uso de redes personales, recaudación de fondos y voluntariado para apoyar el objetivo de la organización benéfica.',
  },
  {
    id: 'radCom',
    title: 'Director/Oficial De Comunicaciones',
    value: 'com',
    info: 'Genera conciencia e interacción a través del marketing y las redes sociales.',
  },
  {
    id: 'radProg',
    title: 'Gerente/Coordinador de programas',
    value: 'prog',
    info: 'Desarrollar y ejecutar estrategias de programas y operaciones diarias para cumplir la misión principal de la organización sin fines de lucro.',
  },
  {
    id: 'radFund',
    title: 'Coordinador de recaudación de fondos',
    value: 'fund',
    info: 'Obtener los recursos necesarios para llevar a cabo la misión de la organización sin fines de lucro.',
  },
  {
    id: 'radVol',
    title: 'Voluntario',
    value: 'vol',
    info: 'Colabora con proyectos benéficos organizando o participando en eventos que apoyen su misión.',
  },
];

export var temp_role = `<div class="role-option">
                        <input
                          type="radio"
                          id="radCeo"
                          name="select-role"
                          value="Founder & CEO"
                        />
                        <label for="radCeo">
                          <span class="role-title">Founder & CEO</span><br />
                          <span class="role-info">Oversees all</span>
                          <div class="locale" style="display: none">
                              <select name="country"></select>
                            </div>
                        </label>
                      </div>`;

export function loadCountries(lang, selCountry) {
  //const selCountry = document.getElementById(elementId);
  if (!selCountry) return;
  const countries = lang != null && lang == 'es' ? countryEsList : countryList;
  const countryCode = countryCodeList;

  for (let index = 0; index < countries.length; index++) {
    const name = countries[index];
    const code = countryCode[index];

    const option = document.createElement('option');
    option.value = code;
    option.textContent = name;
    selCountry.appendChild(option);
  }

  const userLocale =
    navigator.languages.find((lang) => lang.includes('-')) ||
    navigator.language;
  const locale = new Intl.Locale(userLocale);
  const region = locale.region || 'US';
  selCountry.value = region;
}
export function loadLangsList(lang, selLang) {
  if (selLang == null) return;
  const langs = languages;

  selLang.innerHTML = '';

  langs.forEach((langObj) => {
    const option = document.createElement('option');
    option.value = langObj.code;
    option.textContent = langObj.native;
    selLang.appendChild(option);
  });

  let targetLang = 'en';
  if (lang && lang !== 'en') {
    targetLang = lang;
  } else {
    const rawLang = navigator.language || navigator.userLanguage;
    targetLang = rawLang.split('-')[0].toLowerCase();
  }

  selLang.value = targetLang;
}
export function loadLangList(lang, selLang) {
  if (selLang == null) return;
  const langs = languages;
  langs.forEach((lang) => {
    const option = document.createElement('option');
    option.value = lang.code;
    option.textContent = lang.native;
    selLang.appendChild(option);
  });

  if (lang != null && lang != 'en') {
    selLang.value = lang;
  } else {
    const langCode = navigator.language.split('-')[0];
    console.log('browser lang = ' + langCode);

    selLang.value = langCode || 'en';
    console.log('comoon selected lang = ' + selLang.value);
  }
}

export function getCountryName(code, lang) {
  const countries = lang != null && lang == 'es' ? countryEsList : countryList;
  const countryCode = countryCodeList;
  const index = countryCode.indexOf(code);
  return index !== -1 ? countries[index] : '';
}

export function getLanguageName(code) {
  const langObj = languages.find((lang) => lang.code === code);
  return langObj ? langObj.native : '';
}

export function validateEmail(input) {
  let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return reg.test(input);
}

export function validateName(name) {
  // Regex pattern allows letters (a-z, A-Z), spaces, hyphens, and apostrophes
  // The pattern also ensures the name is not empty or just special characters
  var namePattern = /^[a-zA-Z\s-']+$/;

  if (!name || name.trim() === '') {
    return false;
  }

  if (!namePattern.test(name)) {
    return false;
  }

  return true;
}

export var temp_popLoading = `<div id="popLoading" class="popOverlay no-print">
      <div class="content">
        <h3>${getCookie(cookieFbLang) == 'es' ? 'Por favor espera...' : 'Please wait...'}</h3>

        <div class="popInfo v-center">
          <p class="popMsg">${getCookie(cookieFbLang) == 'es' ? 'Procesando tu solicitud...' : 'Processing your request...'}</p>
          <iframe src="https://lottie.host/embed/17bd15e1-c9a2-4c06-b9db-4c238402ba83/zg58YIYAQH.lottie"></iframe>
        </div>
      </div>
    </div>`;

export function addLoadingPopup(parent, show, msg) {
  var div = document.createElement('div');
  div.innerHTML = temp_popLoading;
  if (parent) {
    parent.appendChild(div.firstChild);
  } else {
    document.body.appendChild(div.firstChild);
  }
  if (msg) {
    var popMsg = document.querySelector('#popLoading .popMsg');
    popMsg.textContent = msg;
  }
  if (show) {
    showLoadingPopup(msg);
  }
}
export function togglePopLoading(show, msg, top, parent) {
  let popLoading = document.getElementById('popLoading');
  if (popLoading == null) {
    if (popLoading == null) {
      addLoadingPopup(parent || document.getElementById('main'), false);
      popLoading = document.getElementById('popLoading');
    }
  }
  if (top) {
    popLoading.style.alignItems = 'flex-start';
  }

  if (msg) {
    var popMsg = popLoading.querySelector('.popMsg');
    popMsg.textContent = msg;
  }
  popLoading.style.display = show ? 'flex' : 'none';
}

export function showLoadingPopup(msg) {
  var popup = document.getElementById('popLoading');
  if (!popup) return;
  if (msg) {
    var popMsg = popup.querySelector('.popMsg');
    popMsg.textContent = msg;
  }

  popup.style.display = 'flex';
}

export function setInputError(inputElement, isError, errorMsg, lang) {
  if (isError) {
    inputElement.setCustomValidity(
      errorMsg
        ? errorMsg
        : lang != null && lang == 'es'
          ? 'Información invalida'
          : 'Invalid input',
    );
    inputElement.focus();
  } else {
    inputElement.setCustomValidity('');
  }
}

export function setInputValidity(inputElement, isError, errorMsg) {
  // Find or create an error element container next to the input
  let errorSpan = inputElement.parentNode.querySelector('.dynamic-error-msg');

  if (isError) {
    if (!errorSpan) {
      errorSpan = document.createElement('span');
      errorSpan.className = 'dynamic-error-msg';
      // Style it using standard inline rules or an external CSS class
      // errorSpan.style.color = 'red';
      // errorSpan.style.fontSize = '0.85rem';
      // errorSpan.style.display = 'block';
      // errorSpan.style.marginTop = '4px';

      // Safely insert it right after the input field in the DOM tree
      inputElement.parentNode.insertBefore(
        errorSpan,
        inputElement.previousSibling,
      );
    }
    const defaultMsg = 'Invalid input';
    errorSpan.textContent = errorMsg ? errorMsg : defaultMsg;
    inputElement.classList.add('input-error-border');
  } else {
    // If no error, cleanly strip the generated element and classes out of the DOM
    if (errorSpan) {
      errorSpan.remove();
    }
    inputElement.classList.remove('input-error-border');
  }
}

export function getLoginError(code, lang) {
  let isEs = lang == 'es';
  switch (code) {
    case 'auth/invalid-email':
      return isEs ? 'El correo no es valido' : 'The email is not valid';
    case 'auth/user-disabled':
      return isEs ? 'La cuenta no esta activa' : 'The account is not active';
    case 'auth/user-not-found':
      return isEs ? 'La cuenta no existe' : 'The account does not exist';
    case 'auth/network-request-failed':
      return isEs
        ? 'No se pudo conectar a la red. Inténtalo de nuevo más tarde.'
        : 'Could not connect to the network. Try again later';
    case 'auth/too-many-requests':
      return isEs
        ? 'Demasiados intentos fallidos de inicio de sesión. Inténtalo de nuevo más tarde.'
        : 'Too many failed login attempts. Try again later.';
    default:
      return isEs
        ? 'Correo electrónico o contraseña incorrectos'
        : 'Incorrect email or password';
  }
}

export function getRegisterError(code, lang) {
  let isEs = lang == 'es';
  switch (code) {
    case 'auth/invalid-email':
      return isEs ? 'El correo no es valido' : 'The email is not valid';
    case 'auth/email-already-in-use':
      return isEs
        ? 'La cuenta ya existe con este correo. Inicia sesión en su lugar.'
        : 'An account with this email already exists. Login instead.';
    case 'auth/weak-password':
      return isEs ? 'La contraseña es muy débil.' : 'The password is too weak.';
    case 'auth/network-request-failed':
      return isEs
        ? 'No se pudo conectar a la red. Inténtalo de nuevo más tarde.'
        : 'Could not connect to the network. Try again later';
    case 'auth/too-many-requests':
      return isEs
        ? 'Demasiados intentos fallidos. Inténtalo de nuevo más tarde.'
        : 'Too many failed attempts. Try again later.';
    default:
      return isEs
        ? 'No se pudo crear la cuenta. Intenta de nuevo más tarde.'
        : 'Could not create account. Try again later.';
  }
}

export function validatePassword(pw) {
  return pw.length >= 8;
}

let popConfirm = `<div id="popConfirmOverlay" class="popOverlay no-print">
      <div class="content">
        <h3>Name</h3>
       <p class="pop-msg"></p>
        <div class="h-flex h-even-space">
          <button class="btn-no btn-u-red">No</button>
          <button class="btn-yes btn-green">Yes</button>
        </div>
      </div>
    </div>`;

export function togglePopConfirm(
  lang,
  title,
  msg,
  btnYesMsg,
  btnNoMsg,
  action,
) {
  var popup = document.getElementById('popConfirmOverlay');
  if (!popup) {
    var div = document.createElement('div');
    div.innerHTML = popConfirm;
    document.body.appendChild(div.firstChild);
    popup = div.firstChild;
    var btnClose = popup.querySelector('.btn-no');
    btnClose.addEventListener('click', function () {
      popup.style.display = 'none';
    });
  }

  var popTitle = popup.querySelector('h3');
  var dMsg = popup.querySelector('.pop-msg');
  var btnYes = popup.querySelector('.btn-yes');
  var btnNo = popup.querySelector('.btn-no');
  btnYes.textContent = btnYesMsg || (lang == 'es' ? 'Sí' : 'Yes');
  btnNo.textContent = btnNoMsg || (lang == 'es' ? 'No' : 'No');
  popTitle.textContent = title;
  dMsg.textContent = msg;

  btnYes.addEventListener('click', function () {
    action();
    popup.style.display = 'none';
  });
  popup.style.display = 'flex';
}

let popMsg = `<div id="popUpOverlay">
      <div class="content">
        <h3>Name</h3>
       <p class="pop-msg"></p>
        <div class="h-flex h-even-space">
          <a href="portal.html" class="btn-no-deco-blue">Go to Portal</a>
          <button class="btn-green">Ok</button>
        </div>
      </div>
    </div>`;

export function togglePopMsg(title, msg, isShow, top, link, action) {
  var popup = document.getElementById('popUpOverlay');
  if (!popup) {
    var div = document.createElement('div');
    div.innerHTML = popMsg;
    document.body.appendChild(div.firstChild);
    popup = document.getElementById('popUpOverlay');
    var btnClose = popup.querySelector('.btn-green');
    btnClose.addEventListener('click', function () {
      if (action) {
        action();
      } else {
        popup.style.display = 'none';
      }
    });
  }

  if (top) {
    popup.style.alignItems = 'flex-start';
  }

  var popTitle = popup.querySelector('h3');
  var dMsg = popup.querySelector('.pop-msg');
  var aLink = popup.querySelector('a');
  if (link) {
    aLink.href = link;
    aLink.style.display = 'block';
  } else {
    aLink.style.display = 'none';
  }
  popTitle.textContent = title;
  dMsg.textContent = msg;
  popup.style.display = isShow ? 'flex' : 'none';
}

export function createUser(user, email, id, username) {
  if (user == null) {
    return null;
  }

  return {
    name: user.name,
    id: id ? id : user.id, //auto generated
    email: email,
    img: user.img,
    imgUrl: user.imgUrl,
    date: user.date, //auto generated
    role: user.role,
    desc: user.desc,
    lang: user.lang,
    country: user.country,
    enDesc: user.enDesc, //after revision
    roleLocale: user.roleLocale,
    un: user.un || username, //for username
    dob: user.dob,
  };
}

export function createEmptyUser() {
  return structuredClone(userInfo);
}

export function createEmptyRole() {
  return structuredClone(roleInfo);
}

export var temp_loginPrompt = `<div id="loginRequest">
          <div id="dProgress" class="content">
            <p>${getCookie(cookieFbLang) == 'es' ? 'Preparando solicitud...' : 'Preparing application...'}</p>
            <iframe
              src="https://lottie.host/embed/17bd15e1-c9a2-4c06-b9db-4c238402ba83/zg58YIYAQH.lottie"
            ></iframe>
          </div>
          <div id="dLogin" class="content v-flex">
            <p>${getCookie(cookieFbLang) == 'es' ? 'Inicia sesión o regístrate para ver tu cuenta' : 'Login or register to view your account'}</p>
            <button id="btnLogin" class="btn-blue">${getCookie(cookieFbLang) == 'es' ? 'Iniciar sesión' : 'Login'}</button>
            <p class="light-text">
              <span>----------</span>${getCookie(cookieFbLang) == 'es' ? 'O' : 'Or'}<span>----------</span>
            </p>
            <button id="btnRegister" class="btn-u-blue">${getCookie(cookieFbLang) == 'es' ? 'Registrarme' : 'Register'}</button>
          </div>
        </div>`;

export var temp_loginForm = `<div id="inLogin" class="popOverlay">
        <div class="content h-90 w-80">
          <button class="btn-close-right">${getCookie(cookieFbLang) == 'es' ? 'Cerrar' : 'Close'}</button>
          <iframe
            src="login.html"
            frameborder="0"
            width="100%"
            height="100%"
          ></iframe>
        </div>
      </div>`;
export function toggleLoginForm(show) {
  let inLogin = document.getElementById('inLogin');
  if (inLogin == null) {
    return;
  }
  inLogin.style.display = show ? 'flex' : 'none';
}
export function toggleLoginPrompt(
  from,
  showPop,
  showLogin,
  showLoader,
  getUser = true,
) {
  var loginRequest = document.getElementById('loginRequest');
  if (loginRequest == null) {
    const lang = getCookie(cookieFbLang) || 'en';
    var div = document.createElement('div');
    div.innerHTML = temp_loginPrompt;
    document.body.appendChild(div.firstChild);
    loginRequest = document.getElementById('loginRequest');

    let inLogin = document.getElementById('inLogin');
    if (inLogin == null) {
      var div = document.createElement('div');
      div.innerHTML = temp_loginForm;
      document.body.appendChild(div.firstChild);
      inLogin = document.getElementById('inLogin');
      let btnClose = inLogin.querySelector('.btn-close-right');
      if (lang == 'es') {
        btnClose.textContent = 'Cerrar';
      }
      btnClose.addEventListener('click', function () {
        inLogin.style.display = 'none';
        loginRequest.style.display = 'flex';
      });
    }
    const btnLogin = document.getElementById('btnLogin');
    btnLogin.addEventListener('click', function () {
      loginRequest.style.display = 'none';
      inLogin.querySelector('iframe').src =
        `/login.html?from=${from}&action=login&getUser=${getUser}`;
      inLogin.style.display = 'flex';
    });
    const btnRegister = document.getElementById('btnRegister');
    btnRegister.addEventListener('click', function () {
      loginRequest.style.display = 'none';
      inLogin.querySelector('iframe').src =
        `/login.html?from=${from}&action=register&getUser=${getUser}`;
      inLogin.style.display = 'flex';
    });
  }

  loginRequest.style.display = showPop ? 'flex' : 'none';
  loginRequest.querySelector('#dLogin').style.display = showLogin
    ? 'block'
    : 'none';
  loginRequest.querySelector('#dProgress').style.display = showLoader
    ? 'block'
    : 'none';
}

export let check = `<i class="fa-solid fa-circle-check" style="color: #117453;"></i>`;
export let warn = `<i class="fa-solid fa-triangle-exclamation" style="color: #ff9f1a;"></i>`;
export let error = `<i class="fa-solid fa-circle-exclamation" style="color: #ad0000;"></i>`;
export let info = `<i class="fa-solid fa-circle-info" style="color: #065ff9;"></i>`;
export let elToast = `<div id="toast" class="success">
<div class="h-flex center-items">
  <span
    ><i class="fa-solid fa-circle-check" style="color: #117453"></i
  ></span>
  <p class="ml-8">Success!</p>
</div>
</div>`;
/**
 * Show a snackbar that disappears
 * @param {*} type success, warn, error, info
 * @param {*} msg message to show
 * @param {*} time optional time in milliseconds, default is 3000
 */
export function showToast(type, msg, time) {
  let toast = document.getElementById('toast');
  let spImg, pMsg;
  if (!toast) {
    const container = document.createElement('div');
    container.innerHTML = elToast;
    toast = container.firstChild;
    document.body.appendChild(toast);
  }

  spImg = toast.querySelector('span');
  pMsg = toast.querySelector('p');

  toast.className = type;

  switch (type) {
    case 'warn':
      spImg.innerHTML = warn;
      break;
    case 'error':
      spImg.innerHTML = error;
      break;
    case 'info':
      spImg.innerHTML = info;
      break;
    case 'success':
    default:
      spImg.innerHTML = check;
      break;
  }

  pMsg.textContent = msg;
  toast.classList.add('show');
  console.log('will toast');
  // After 3 seconds, remove the show class from toast
  setTimeout(
    function () {
      toast.classList.remove('show');
    },
    time ? time : 3000,
  );
}
const msgLoader = `<div id="loadingOverlay" class="loading-overlay" aria-live="assertive" role="alert">
  <div class="loader-container">
    <div class="spinner"></div>
    <p id="loadingMessage" class="loading-text">Loading, please wait...</p>
  </div>
</div>`;

export function showMsgLoader(msg = i18n.t('msg_loading')) {
  let loadingOverlay = document.getElementById('loadingOverlay');
  if (!loadingOverlay) {
    const container = document.createElement('div');
    container.innerHTML = msgLoader;
    loadingOverlay = container.firstChild;
    document.body.appendChild(loadingOverlay);
  }
  const loadingMessage = loadingOverlay.querySelector('#loadingMessage');
  loadingMessage.textContent = msg;
  loadingOverlay.classList.add('active');
}

export function updateMsgLoader(msg = i18n.t('msg_loading')) {
  let loadingOverlay = document.getElementById('loadingOverlay');
  if (loadingOverlay) {
    const loadingMessage = loadingOverlay.querySelector('#loadingMessage');
    loadingMessage.textContent = msg;
  }
}

export function hideMsgLoader() {
  let loadingOverlay = document.getElementById('loadingOverlay');
  console.log('loading overlay: ', loadingOverlay);

  if (loadingOverlay) {
    loadingOverlay.classList.remove('active');
  }
}

const temp_campaignCard = `<div class="campaign-card">
              <img
                class="campaign-image exam"
                src="images/pexel/medical.jpg"
                alt="Medical Aid"
              />
              <div class="campaign-overlay">
                <h3 class="campaign-title" data-i18n="medical_aid">
                  Medical Aid
                </h3>
                <a
                  class="campaign-btn"
                  href="user/camp1"
                  data-i18n="view_impact"
                  >View Impact</a
                >
              </div>
            </div>`;

export function createCampaignCard() {
  const container = document.createElement('div');
  container.innerHTML = temp_campaignCard;
  return container.firstChild;
}

const temp_videoItem = `<div class="gallery-item">
                <video class="media-src" src="videos/tiktok.mp4"></video>
                <div title="Play video" aria-label="Play video" data-i18n-attr='{"aria-label":"play_video","title":"play_video"}' class="video-play-icon">▶</div>
              </div>`;

const temp_imgItem = `<div class="gallery-item">
                <img class="media-src" src="images/parents.png" alt="" />
                <div class="gallery-overlay">
                  <span data-i18n="view_preview">View Image</span>
                </div>
              </div>`;
export function createMediaItem(type = 'image') {
  const container = document.createElement('div');
  if (type === 'video') {
    container.innerHTML = temp_videoItem;
  } else {
    container.innerHTML = temp_imgItem;
  }
  i18n.translatePage(container);
  return container.firstChild;
}
const temp_imgWrapper = `<div class="gallery-item">
                          <img
                            src="images/svg/ph-img.svg"
                            alt="Gallery image"
                            data-i18n-attr='{"alt":"gallery_image"}'
                          />
                          <div class="gallery-overlay-mock">
                            <i
                              class="fa-solid fa-arrow-left cancel"
                              style="color: rgb(202, 202, 202)"
                              aria-label="Go back"
                              title="Go back"
                              data-i18n-attr='{"aria-label":"go_back","title":"go_back"}'
                            ></i>
                            <i
                              class="fa-solid fa-trash-can remove"
                              aria-label="Delete image"
                              title="Delete image"
                              data-i18n-attr='{"aria-label":"delete_image","title":"delete_image"}'
                            ></i>
                          </div>
                        </div>`;
export function createImgWrapper() {
  const container = document.createElement('div');
  container.innerHTML = temp_imgWrapper;
  return container.firstChild;
}

const temp_fileItem = `<div class="receipt-item">
                    <i class="fa-solid fa-check-double uploaded-icon"></i>
                    <a
                      href="#"
                      target="_blank"
                      rel="noopener"
                      class="receipt-title"
                      >Receipt title</a
                    >
                    <button
                      class="btn-icon-delete"
                      aria-label="Delete file"
                      title="Delete file"
                      data-i18n-attr='{"aria-label":"delete_file", "title":"delete_file"}'
                    >
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  </div>`;

export function createFileItem() {
  const container = document.createElement('div');
  container.innerHTML = temp_fileItem;
  return container.firstChild;
}
export function getFileNameFromUrl(url) {
  // Extract path between /o/ and the query parameters (?)
  const filePath = url.split('/o/')[1].split('?')[0];
  // Decode the URL-encoded characters (like %2F to /)
  const decodedPath = decodeURIComponent(filePath);
  // Get the final item in the path array
  return decodedPath.split('/').pop();
}
export let temp_inputEdit = `<div id="inputEdit" class="popOverlay" style="display: flex">
        <div class="content w-50">
          <p class="bold green-txt" id="pTitle">Title</p>
          <p id="pMsg" class="sm-txt">Message</p>
          <input type="text" id="inEdit" placeholder="Name" />

          <div class="res-h-flex h-even-space margin-10 mt-48">
            <button class="btn-no-deco-gray btn-no">Cancel</button>
            <button class="btn-green btn-yes">Save changes</button>
          </div>
        </div>
      </div>`;

export function showInputEdit(
  lang,
  title,
  msg,
  inputType,
  defaultVal,
  placeholder,
  onSave,
) {
  let inputEdit = document.getElementById('inputEdit');
  if (!inputEdit) {
    const container = document.createElement('div');
    container.innerHTML = temp_inputEdit;
    inputEdit = container.firstChild;
    document.body.appendChild(inputEdit);
  }
  let pTitle = inputEdit.querySelector('#pTitle');
  let pMsg = inputEdit.querySelector('#pMsg');
  let inEdit = inputEdit.querySelector('#inEdit');
  let btnNo = inputEdit.querySelector('.btn-no');
  let btnYes = inputEdit.querySelector('.btn-yes');
  inEdit.type = inputType ? inputType : 'text';
  inEdit.focus();
  pTitle.textContent = title;
  pMsg.textContent = msg;
  inEdit.value = defaultVal ? defaultVal : '';
  inEdit.placeholder = placeholder ? placeholder : '';
  btnYes.onclick = function () {
    if (onSave) {
      let val = inEdit.value.trim();
      if (val == '') {
        showToast(
          'warn',
          lang == 'es'
            ? 'El campo no puede estar vacío'
            : 'Input cannot be empty',
        );
        inEdit.focus();
        return;
      } else if (val == defaultVal) {
        showToast(
          'warn',
          lang == 'es' ? 'El valor no ha cambiado' : 'Value has not changed',
        );
        inEdit.focus();
        return;
      }
      onSave(val);
    }
    inputEdit.style.display = 'none';
  };
  btnNo.onclick = function () {
    inputEdit.style.display = 'none';
  };
}

export const campaignPrograms = [
  {
    title: 'Health Care',
    val: 'health',
    i18n: 'health_care',
  },
  {
    title: 'Education & Literacy',
    val: 'education',
    i18n: 'education_literacy',
  },
  {
    title: 'Hunger Relief',
    val: 'meals',
    i18n: 'hunger_relief',
  },
  {
    title: 'Disaster Relief',
    val: 'disaster',
    i18n: 'disaster_relief',
  },
  {
    title: 'Animal Welfare',
    val: 'animal',
    i18n: 'animal_welfare',
  },
];

export function loadCampaignPrograms(selCampaign) {
  if (selCampaign == null) return;
  campaignPrograms.forEach((program) => {
    const option = document.createElement('option');
    option.value = program.val;
    option.textContent = program.title;
    option.setAttribute('data-i18n', program.i18n);
    selCampaign.appendChild(option);
  });
}

export const programs = [
  {
    title: 'Disaster relief',
    type: 'Disaster',
    val: 'disaster',
  },
  {
    title: 'Financial Medical Aid',
    type: 'Medical',
    val: 'medical',
  },
  {
    title: 'Utilities Assistance',
    type: 'Utilities',
    val: 'utilities',
  },
  {
    title: 'Student Aid',
    type: 'Student',
    val: 'student',
  },
];
export const programsEs = [
  {
    title: 'Ayuda En Caso De Desastre',
    type: 'Desastre',
    val: 'disaster',
  },
  {
    title: 'Ayuda médica financiera',
    type: 'Médica',
    val: 'medical',
  },
  {
    title: 'Asistencia con los servicios públicos',
    type: 'Servicios públicos',
    val: 'utilities',
  },
  {
    title: 'Ayuda Para Estudiantes',
    type: 'Estudiante',
    val: 'student',
  },
];

export const status = [
  { title: 'Pending', value: 'pending' },
  {
    title: 'Incomplete',
    value: 'incomplete',
  },
  {
    title: 'Approved - Waiting for Payment',
    value: 'approved',
  },
  {
    title: 'Denied',
    value: 'denied',
  },
  { title: 'Completed', value: 'completed' },
];

export const statusEs = [
  { title: 'Pendiente', value: 'pending' },
  {
    title: 'Incompleto',
    value: 'incomplete',
  },
  {
    title: 'Aprovado - Esperando Pago',
    value: 'approved',
  },
  {
    title: 'Denegado',
    value: 'denied',
  },
  { title: 'Completado', value: 'completed' },
];

export function initPrograms(lang, selProgram) {
  if (selProgram == null) return;
  const programList = lang == 'es' ? programsEs : programs;
  programList.forEach((program) => {
    const option = document.createElement('option');
    option.value = program.val;
    option.textContent = program.title;
    selProgram.appendChild(option);
  });
}

export function initStatusOptions(lang, selStatus) {
  const statusList = lang == 'es' ? statusEs : status;
  statusList.forEach((status) => {
    const option = document.createElement('option');
    option.value = status.value;
    option.textContent = status.title;
    selStatus.appendChild(option);
  });
}

export let temp_fileUpload = `<div class="file">
                    <span class="file-name sm-font">Name</span>
                    <button class="remove btn-no-deco-gray">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </div>`;
export function validateDOB(dateString) {
  const dob = new Date(dateString);
  const today = new Date();

  // 1. Valid date check
  if (isNaN(dob.getTime())) return false;

  // 2. Not in the future
  if (dob > today) return false;

  // 3. Realistic age range (e.g., max 120 years old)
  const minDate = new Date();
  minDate.setFullYear(today.getFullYear() - 120);
  if (dob < minDate) return false;

  return true;
}
export function formatMoney(value) {
  if (value) {
    return parseFloat(value).toFixed(2);
  } else {
    return null;
  }
}
export function validatePhone(phone) {
  const pattern = /^[0-9\-]{6,12}$/; ///^(?!-+$)[0-9-]+$/;

  return pattern.test(phone);
}
export var donee = {
  date: null,
  uid: null,
  staffId: null,
};

export function newDonee() {
  return structuredClone(donee);
}
export var denied = {
  date: null,
  uid: null,
  staffId: null,
};

export function newDenied() {
  return structuredClone(denied);
}

export var simpleHelp = {
  date: null,
  uid: null,
  staffId: null,
};

export function newSimpleHelp() {
  return structuredClone(simpleHelp);
}
export var donation = {
  date: null,
  amount: null,
  uid: null,
  staffId: null,
};
export function newDonation() {
  return structuredClone(donation);
}
export var helpForm = {
  date: null, //date form submitted
  name: null,
  contact: null,
  address: null,
  program: null,
  phone: null,
  text: null, //contact type
  call: null, //contact type
  email: null, //contact type
  employment: null,
  houseSize: null,
  income: null,
  expenses: null,
  requestAmount: null,
  repairCost: null,
  insuranceName: null,
  policyNum: null,
  insurancePhone: null,
  desc: null,
  signDate: null,
  signature: null,
  medBill: null,
  hospitalName: null,
  hospitalAddress: null,
  schoolName: null,
  schoolAddress: null,
  schoolPhone: null,
  status: 'pending',
  note: null, //info from staff:comments, denial reason
  uid: null, //user's id
  dob: null, //user's date of birth
  key: null, //form key
  staffId: null,
  staffName: null,
  staffDate: null,
  approvedDate: null,
  approvedAmount: null,
  payType: null,
  payDate: null,
};
export function newHelpForm() {
  return structuredClone(helpForm);
}
export function copyHelpForm(form, staffId, staffName) {
  if (form == null) {
    return null;
  }

  return {
    date: form.date, //date form submitted
    name: form.name,
    contact: form.contact,
    address: form.address,
    program: form.program,
    phone: form.phone,
    text: form.text, //contact type
    call: form.call, //contact type
    email: form.email, //contact type
    employment: form.employment,
    houseSize: form.houseSize,
    income: form.income,
    expenses: form.expenses,
    requestAmount: form.requestAmount,
    repairCost: form.repairCost,
    insuranceName: form.insuranceName,
    policyNum: form.policyNum,
    insurancePhone: form.insurancePhone,
    desc: form.desc,
    signDate: form.signDate,
    signature: form.signature,
    medBill: form.medBill,
    hospitalName: form.hospitalName,
    hospitalAddress: form.hospitalAddress,
    schoolName: form.schoolName,
    schoolAddress: form.schoolAddress,
    schoolPhone: form.schoolPhone,
    status: form.status || 'pending',
    note: form.note, //info from staff:comments, denial reason
    uid: form.uid, //user's id
    dob: form.dob, //user's date of birth
    key: form.key, //form key
    staffId: form.staffId ? `${form.staffId}, ${staffId}` : staffId,
    staffName: form.staffName ? `${form.staffName}, ${staffName}` : staffName,
    staffDate: form.staffDate,
    approvedAmount: form.approvedAmount,
    payType: form.payType,
  };
}
export function formatInputDate(time) {
  let date = time ? new Date(time) : new Date();
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatDisplayDate(time) {
  let date = time ? new Date(time) : new Date();
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');
  return `${month}/${day}/${year}`;
}

export function formatDisplayTime(time) {
  let date = time ? new Date(time) : new Date();
  let hours = date.getHours().toString().padStart(2, '0');
  let hr = (hours % 12 || 12).toString().padStart(2, '0');
  let minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hr}:${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
}

export var temp_helpFormLog = `<td>
                    <div class="program-type">Program Name</div>
                  </td>
                  <td class="date">00/00/0000</td>
                  <td class="status">Pending</td>
                  <td class="actions">
                    <button class="btn-view">
                      <span>View</span><i class="fa-solid fa-eye"></i>
                    </button>
                  </td>`;

export function createHelpFormLog(formId, form, lang, action) {
  const parent = document.createElement('tr');
  parent.style.textAlign = 'center';
  parent.innerHTML = temp_helpFormLog;

  parent.querySelector('.program-type').textContent =
    lang == 'es'
      ? programsEs.find((p) => p.val == form.program)?.title || form.program
      : programs.find((p) => p.val == form.program)?.title || form.program;
  parent.querySelector('.date').textContent = form.date
    ? formatDisplayDate(form.date)
    : '';
  parent.querySelector('.status').textContent =
    lang == 'es'
      ? statusEs.find((s) => s.value == form.status)?.title || form.status
      : status.find((s) => s.value == form.status)?.title || form.status;
  const btnView = parent.querySelector('.btn-view');
  btnView.querySelector('span').textContent = lang == 'es' ? 'Ver' : 'View';
  btnView.onclick = function () {
    action(formId, form);
  };
  parent.id = formId;
  return parent;
}

export var temp_helpFormFile = `<td class="file-name">File Name</td>
                        <td class="file-type">PDF</td>
                        <td class="file-size">1.2 MB</td>
                        <td class="date sm-font">00:00 00/00/0000</td>
                        <td class="actions">
                          <div class="v-flex no-print">
                            <button class="btn-view btn-u-white btn-icon mb-10">
                              <i class="fa-solid fa-eye"></i><span>View</span>
                            </button>
                            <button class="btn-delete btn-u-white btn-icon">
                              <i class="fa-solid fa-trash"></i
                              ><span>Delete</span>
                            </button>
                          </div>
                        </td>`;

export function createHelpFormFile(
  lang,
  fileInfo,
  fileId,
  viewAction,
  deleteAction,
) {
  const parent = document.createElement('tr');
  parent.style.textAlign = 'center';
  parent.innerHTML = temp_helpFormFile;
  parent.querySelector('.file-name').textContent =
    fileInfo.name || (lang == 'es' ? 'Archivo sin nombre' : 'Unnamed file');
  parent.querySelector('.file-type').textContent =
    fileInfo.type || (lang == 'es' ? 'Desconocido' : 'Unknown');
  parent.querySelector('.file-size').textContent = fileInfo.size
    ? formatBytes(fileInfo.size)
    : '--';
  parent.querySelector('.date').textContent = fileInfo.date
    ? `${formatDisplayTime(fileInfo.date)} ${formatDisplayDate(fileInfo.date)}`
    : '';

  const btnView = parent.querySelector('.btn-view');
  btnView.querySelector('span').textContent = lang == 'es' ? 'Ver' : 'View';
  btnView.onclick = function () {
    viewAction(fileId, fileInfo);
  };
  const btnDelete = parent.querySelector('.btn-delete');
  btnDelete.querySelector('span').textContent =
    lang == 'es' ? 'Eliminar' : 'Delete';
  btnDelete.onclick = function () {
    deleteAction(fileId, fileInfo);
  };
  parent.id = `file-${fileId}`;
  return parent;
}

/**
 * Converts bytes to a human-readable format.
 * @param {number} bytes The numeric value in bytes.
 * @param {number} decimals How many decimal places to include (default 2).
 */
export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  // Calculate the index of the unit to use
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  // Calculate the value and fix the decimal points
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export var temp_listItem = `<div class="h-flex round-white pad-10 mb-20">
                <img
                  src="images/svg/ph-user.svg"
                  alt="User profile image"
                  class="pointer user-img-top"
                />
                <div class="v-flex ml-20 w-100 pointer">
                  <div class="h-flex">
                    <div class="name bold fill">John Doe</div>
                    <div class="time font-small mr-10">12:00 PM</div>
                    <div class="date font-small">00/00/0000</div>
                  </div>
                  <div class="info">Program Name</div>
                </div>
                <span class="self-center pointer"
                  ><i class="fa-solid fa-angle-right"></i
                ></span>
              </div>`;

export function createAssistItem(
  assist,
  helpUid,
  helpKey,
  imgUrl,
  lang,
  action,
) {
  const container = document.createElement('div');
  container.innerHTML = temp_listItem;
  const item = container.firstChild;
  item.id = `${helpUid}-${helpKey}`;
  //add erro listener to img
  console.log('img: ', imgUrl);

  if (imgUrl != null && imgUrl == -1) {
    item.querySelector('img').style.display = 'none';
  } else {
    item.querySelector('img').addEventListener('error', function (event) {
      event.target.src = phUser;
    });
    item.querySelector('img').src = imgUrl || phUser;
  }

  item.querySelector('.name').textContent = assist.name;
  item.querySelector('.info').textContent =
    lang == 'es'
      ? programsEs.find((p) => p.val == assist.program)?.title || assist.program
      : programs.find((p) => p.val == assist.program)?.title || assist.program;
  item.querySelector('.time').textContent = formatDisplayTime(assist.date);
  item.querySelector('.date').textContent = formatDisplayDate(assist.date);
  item.onclick = function () {
    if (action) {
      action(helpKey, helpUid, assist);
    }
  };
  return item;
}

export function createHireItem(
  hireInfo,
  hireKey,
  hireUid,
  imgUrl,
  action,
  lang,
) {
  const container = document.createElement('div');
  container.innerHTML = temp_listItem;
  const item = container.firstChild;
  item.id = `${hireUid}-${hireKey}`;
  item.querySelector('img').addEventListener('error', function (event) {
    event.target.src = phUser;
  });
  item.querySelector('img').src = imgUrl || phUser;
  item.querySelector('.name').textContent = hireInfo.name;
  item.querySelector('.info').textContent =
    lang == 'es'
      ? rolesEs.find((r) => r.value == hireInfo.role)?.title || hireInfo.role
      : roles.find((r) => r.value == hireInfo.role)?.title || hireInfo.role;
  item.querySelector('.time').textContent = formatDisplayTime(hireInfo.date);
  item.querySelector('.date').textContent = formatDisplayDate(hireInfo.date);
  item.onclick = function () {
    action(hireInfo, hireUid);
  };
  return item;
}

const temp_linkShare = `<div class="modal-overlay" id="modalOverlay">
        <div class="share-modal">
            <div class="modal-header">
                <h3 data-i18n="share">Share</h3>
                <button class="close-btn" id="closeShare">&times;</button>
            </div>

            <!-- Social Media Grid -->
            <div class="social-networks">
                <a href="#" target="_blank" class="social-btn" id="shareFB">
                    <div class="icon-wrapper facebook">FB</div>
                    Facebook
                </a>
                <a href="#" target="_blank" class="social-btn" id="shareX">
                    <div class="icon-wrapper x-twitter">X</div>
                    X / Twitter
                </a>
                <a href="#" target="_blank" class="social-btn" id="shareLI">
                    <div class="icon-wrapper linkedin">In</div>
                    LinkedIn
                </a>
                <a href="#" target="_blank" class="social-btn" id="shareWA">
                    <div class="icon-wrapper whatsapp">WA</div>
                    WhatsApp
                </a>
            </div>

            <!-- Copy Link Bar -->
            <div class="copy-link-section">
                <input type="text" class="link-input" id="shareUrlInput" readonly>
                <button class="copy-btn" id="copyLinkBtn" data-i18n="copy">Copy</button>
            </div>
        </div>
    </div>`;

export function showShareModal(show, url, shareText = i18n.t('share_text')) {
  let modalOverlay = document.getElementById('modalOverlay');
  if (!show) {
    if (modalOverlay) {
      modalOverlay.style.display = 'none';
    }
    return;
  }
  if (!modalOverlay) {
    const container = document.createElement('div');
    container.innerHTML = temp_linkShare;
    modalOverlay = container.firstChild;
    document.body.appendChild(modalOverlay);
  }
  const h3 = modalOverlay.querySelector('h3');
  h3.textContent = i18n.t('share');
  const shareUrlInput = document.getElementById('shareUrlInput');
  shareUrlInput.value = url;
  const closeModal = () => {
    modalOverlay.classList.remove('active');
  };
  const closeShare = document.getElementById('closeShare');
  closeShare.onclick = function () {
    closeModal();
  };

  const copyLinkBtn = document.getElementById('copyLinkBtn');
  copyLinkBtn.textContent = i18n.t('copy');
  copyLinkBtn.onclick = async function () {
    try {
      await navigator.clipboard.writeText(url);

      // Visual confirmation handling
      copyLinkBtn.textContent = 'Copied!';
      copyLinkBtn.classList.add('copied');

      // Revert state after a delayed duration
      setTimeout(() => {
        copyLinkBtn.textContent = 'Copy';
        copyLinkBtn.classList.remove('copied');
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  const shareFB = document.getElementById('shareFB');
  shareFB.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    url,
  )}`;

  const shareX = document.getElementById('shareX');
  shareX.href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    url,
  )}&text=${encodeURIComponent(shareText)}`;

  const shareLI = document.getElementById('shareLI');
  shareLI.href = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
    url,
  )}`;

  const shareWA = document.getElementById('shareWA');
  shareWA.href = `https://api.whatsapp.com/send?text=${encodeURIComponent(
    shareText + ' ' + url,
  )}`;

  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) closeModal();
  });

  modalOverlay.classList.add('active');
}

const temp_campaignCreated = `<div class="modal-overlay" id="campaignCreatedOverlay">
  <div class="campaign-created-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h3 data-i18n="campaign_submitted">Campaign Submitted</h3>
        <button class="close-btn" id="closeCampaignCreated">&times;</button>
      </div>
      <p data-i18n="campaign_submitted_msg">Your campaign has been successfully created!</p>
      <p data-i18n="campaign_pending_msg">Your campaign is pending approval.</p>
      <div class="modal-actions">
        <button class="btn-blue" id="okCampaignCreated" data-i18n="ok">OK</button>
      </div>
    </div>
  </div>
</div>
`;
export function showCampaignCreatedModal(show, onOk) {
  let modalOverlay = document.getElementById('campaignCreatedOverlay');

  if (!show) {
    if (modalOverlay) {
      modalOverlay.classList.remove('active');
    }
    return;
  }

  // 1. Create the modal if it doesn't exist
  if (!modalOverlay) {
    const container = document.createElement('div');
    container.innerHTML = temp_campaignCreated.trim(); // .trim() safely prevents whitespace bugs
    modalOverlay = container.firstElementChild;
    document.body.appendChild(modalOverlay);

    // Static event listener (this one never needs to change)
    const closeBtn = modalOverlay.querySelector('#closeCampaignCreated');
    closeBtn.addEventListener('click', () =>
      modalOverlay.classList.remove('active'),
    );
  }

  // 2. Dynamic event handler (updates every time the function is called)
  const okBtn = modalOverlay.querySelector('#okCampaignCreated');
  okBtn.onclick = () => {
    if (onOk) onOk();
    modalOverlay.classList.remove('active');
  };

  // 3. Update text content and display
  modalOverlay.querySelector('h3').textContent = i18n.t('campaign_submitted');
  modalOverlay.querySelector('p:nth-of-type(1)').textContent = i18n.t(
    'campaign_submitted_msg',
  );
  modalOverlay.querySelector('p:nth-of-type(2)').textContent = i18n.t(
    'campaign_pending_msg',
  );

  modalOverlay.classList.add('active');
}

export function createInvoiceRow(
  container,
  invoiceData,
  isAdmin = false,
  actionHandlers = {},
) {
  const temp_emptyInvoice = `<tr class="invoice-tr">
    <td class="invoice-key">${invoiceData.key}</td>
    <td class="invoice-name">${invoiceData.name}</td>
    <td class="invoice-total">$${invoiceData.usdTotal}</td>
    <td class="invoice-status ${invoiceData.status}"><span>${i18n.t(invoiceData.status)}</span></td>
    <td class="invoice-date">${formatDisplayDate(invoiceData.date)}</td>
    <td class="invoice-review-date">${formatDisplayDate(invoiceData.reviewDate)}</td>
    <td class="invoice-actions">
      <!-- Shortcut 1: Manage/Edit Case Profile Popup Overlay -->
      <button
        class="btn-tr-edit ${isAdmin ? '' : 'hidden'}"
        aria-label="Edit"
        title="Edit"
        data-i18n-attr='{"aria-label":"edit","title":"edit" }'
      >
        <i
          class="fa-solid fa-pen-to-square"
          style="color: rgb(30, 48, 80)"
        ></i>
      </button>

      <button
        class="btn-tr-view"
        aria-label="View"
        title="View"
        data-i18n-attr='{"aria-label":"view","title":"view" }'
      >
        <i
          class="fa-solid fa-eye"
          style="color: rgb(30, 48, 80)"
        ></i>
      </button>

      <button
        class="btn-tr-delete ${isAdmin ? '' : 'hidden'}"
        aria-label="Delete"
        title="Delete"
        data-i18n-attr='{"aria-label":"delete","title":"delete" }'
      >
        <i
          class="fa-solid fa-trash"
          style="color: rgb(30, 48, 80)"
        ></i>
      </button>
    </td>
  </tr>`;
  const parent = document.createElement('tr');
  parent.classList.add('invoice-tr');
  parent.id = invoiceData.key;
  parent.innerHTML = temp_emptyInvoice;
  const btnEdit = parent.querySelector('.btn-tr-edit');
  const btnView = parent.querySelector('.btn-tr-view');
  const btnDelete = parent.querySelector('.btn-tr-delete');
  btnEdit.onclick = () => {
    if (actionHandlers.onEdit) actionHandlers.onEdit(invoiceData);
  };
  btnView.onclick = () => {
    if (actionHandlers.onView) actionHandlers.onView(invoiceData);
  };
  btnDelete.onclick = () => {
    if (actionHandlers.onDelete) actionHandlers.onDelete(invoiceData);
  };
  i18n.translatePage(parent);
  const oldRow = container.querySelector(`#${invoiceData.key}`);
  if (oldRow) {
    container.replaceChild(parent, oldRow);
  } else {
    container.appendChild(parent);
  }
}

const temp_confirmDialog = `<dialog id="dynamicConfirmDialog" class="dialog-box">
  <div class="dialog-content">
    <h3 id="dialogTitle">Confirm Action</h3>
    <p id="dialogMessage">Are you sure you want to proceed?</p>
    <div class="dialog-actions">
      <button id="dialogCancelBtn" class="btn btn-secondary-dialog" data-i18n="cancel">Cancel</button>
      <button id="dialogConfirmBtn" class="btn" data-i18n="confirm">Confirm</button>
    </div>
  </div>
</dialog>`;

/**
 * Triggers a custom confirmation dialog box.
 * @param {Object} options - Configuration properties.
 * @param {string} options.title - The heading text.
 * @param {string} options.message - The descriptive paragraph text.
 * @param {string} [options.confirmText="Confirm"] - Text for the confirm button.
 * @param {string} [options.cancelText="Cancel"] - Text for the cancel button.
 * @param {string} [options.confirmType="primary"] - Visual style type ('primary' or 'danger').
 * @returns {Promise<boolean>} Resolves to true if confirmed, false if cancelled.
 */
export function showConfirmDialog({
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmType = 'primary',
}) {
  let dialog = document.getElementById('dynamicConfirmDialog');
  if (!dialog) {
    const container = document.createElement('div');
    container.innerHTML = temp_confirmDialog;
    dialog = container.firstChild;
    document.body.appendChild(dialog);
  }

  return new Promise((resolve) => {
    const dialog = document.getElementById('dynamicConfirmDialog');
    const titleEl = document.getElementById('dialogTitle');
    const msgEl = document.getElementById('dialogMessage');
    const cancelBtn = document.getElementById('dialogCancelBtn');
    const confirmBtn = document.getElementById('dialogConfirmBtn');

    // 1. Inject content dynamically
    titleEl.textContent = title;
    msgEl.textContent = message;
    cancelBtn.textContent = cancelText;
    confirmBtn.textContent = confirmText;

    // 2. Set button design theme class dynamically
    confirmBtn.className = `btn ${confirmType === 'danger' ? 'btn-danger' : 'btn-primary'}`;

    // 3. Define event handlers
    const handleConfirm = () => {
      cleanup();
      resolve(true);
    };

    const handleCancel = () => {
      cleanup();
      resolve(false);
    };

    const handleBackdropClick = (e) => {
      const rect = dialog.getBoundingClientRect();
      if (
        e.clientX < rect.left ||
        e.clientX > rect.right ||
        e.clientY < rect.top ||
        e.clientY > rect.bottom
      ) {
        handleCancel();
      }
    };

    const handleKeydown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault(); // Control behavior manually
        handleCancel();
      }
    };

    // 4. Detach event listeners to prevent memory leaks or dual resolutions
    const cleanup = () => {
      confirmBtn.removeEventListener('click', handleConfirm);
      cancelBtn.removeEventListener('click', handleCancel);
      dialog.removeEventListener('click', handleBackdropClick);
      dialog.removeEventListener('keydown', handleKeydown);
      dialog.close();
    };

    // 5. Attach event listeners
    confirmBtn.addEventListener('click', handleConfirm);
    cancelBtn.addEventListener('click', handleCancel);
    dialog.addEventListener('click', handleBackdropClick);
    dialog.addEventListener('keydown', handleKeydown);

    // 6. Present modal layout
    dialog.showModal();
  });
}

const temp_singleConfirmDialog = `<dialog id="singleDynamicConfirmDialog" class="dialog-box">
  <div class="dialog-content">
    <h3 id="dialogTitle" data-i18n="confirm_action">Confirm Action</h3>
    <p id="dialogMessage">Are you sure you want to proceed?</p>
    <div class="dialog-actions">
      <button id="dialogConfirmBtn" class="btn" data-i18n="confirm">Confirm</button>
    </div>
  </div>
</dialog>`;

/**
 * Triggers a custom confirmation dialog box.
 * @param {Object} options - Configuration properties.
 * @param {string} options.title - The heading text.
 * @param {string} options.message - The descriptive paragraph text.
 * @param {string} [options.confirmText="Confirm"] - Text for the confirm button.
 * @param {string} [options.cancelText="Cancel"] - Text for the cancel button.
 * @param {string} [options.confirmType="primary"] - Visual style type ('primary' or 'danger').
 * @returns {Promise<boolean>} Resolves to true if confirmed, false if cancelled.
 */
export function showSingleConfirmDialog({
  title,
  message,
  confirmText = 'Confirm',
  confirmType = 'primary',
}) {
  let dialog = document.getElementById('singleDynamicConfirmDialog');
  if (!dialog) {
    const container = document.createElement('div');
    container.innerHTML = temp_singleConfirmDialog;
    dialog = container.firstChild;
    document.body.appendChild(dialog);
  }

  return new Promise((resolve) => {
    const dialog = document.getElementById('singleDynamicConfirmDialog');
    const titleEl = document.getElementById('dialogTitle');
    const msgEl = document.getElementById('dialogMessage');
    const confirmBtn = document.getElementById('dialogConfirmBtn');

    // 1. Inject content dynamically
    console.log('arguments: ', title, message);

    titleEl.textContent = title;
    msgEl.textContent = message;
    confirmBtn.textContent = confirmText;
    titleEl.setAttribute('data-i18n', title);
    msgEl.setAttribute('data-i18n', message);
    confirmBtn.setAttribute('data-i18n', confirmText);
    i18n.translatePage(dialog);
    // 2. Set button design theme class dynamically
    confirmBtn.className = `btn ${confirmType === 'danger' ? 'btn-danger' : 'btn-primary'}`;

    // 3. Define event handlers
    const handleConfirm = () => {
      cleanup();
      resolve(true);
    };

    const handleCancel = () => {
      cleanup();
      resolve(true);
    };

    const handleBackdropClick = (e) => {
      const rect = dialog.getBoundingClientRect();
      if (
        e.clientX < rect.left ||
        e.clientX > rect.right ||
        e.clientY < rect.top ||
        e.clientY > rect.bottom
      ) {
        handleCancel();
      }
    };

    const handleKeydown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault(); // Control behavior manually
        handleCancel();
      }
    };

    // 4. Detach event listeners to prevent memory leaks or dual resolutions
    const cleanup = () => {
      confirmBtn.removeEventListener('click', handleConfirm);
      dialog.removeEventListener('click', handleBackdropClick);
      dialog.removeEventListener('keydown', handleKeydown);
      dialog.close();
    };

    // 5. Attach event listeners
    confirmBtn.addEventListener('click', handleConfirm);
    dialog.addEventListener('click', handleBackdropClick);
    dialog.addEventListener('keydown', handleKeydown);

    // 6. Present modal layout
    dialog.showModal();
  });
}

export function toggleSkeleton(enable = true, element) {
  if (!element) return;
  if (typeof element === 'string') {
    element = document.body.querySelector(element);
  }

  if (enable) {
    element.classList.add('loading-skeleton');
  } else {
    element.classList.remove('loading-skeleton');
  }
}

// example on how to call a function from function caller
/**
 * Show a confirmation dialog with message and action buttons
 * @param {*} msg Message to show
 * @param {*} onYes function to fire when yes button clicked
 */
// export function showConfirmModal(title, msg, onYes) {
//   let confirmModal = document.getElementById("confirmModal");
//   let pTitle, pMsg, btnNo, btnYes;

//   if (!confirmModal) {
//     const container = document.createElement("div");
//     container.innerHTML = elConfirmModal;
//     confirmModal = container.firstChild;
//     document.body.appendChild(confirmModal);
//   }
//   pTitle = confirmModal.querySelector(".mod-title");
//   pMsg = confirmModal.querySelector(".mod-msg");
//   btnNo = confirmModal.querySelector(".btn-no");
//   btnYes = confirmModal.querySelector(".btn-yes");

//   pTitle.textContent = title ? title : "Confirm";
//   pMsg.textContent = msg;

//   $(btnYes).on("click", function () {
//     if (onYes) {
//       onYes();
//     }
//     setDisplay(confirmModal, "none");
//   });

//   $(btnNo).on("click", function () {
//     setDisplay(confirmModal, "none");
//   });
//   setDisplay(confirmModal, "flex");
// }

// function confirmLogout() {
//   showConfirmModal(null, "Are you sure you want to logout?", logout);
// }

// function logout() {
//   signOut(auth)
//     .then(() => {
//       showToast("success", "Signed out successfully", null);
//     })
//     .catch((_e) => {
//       showToast("error", "Could not sign you out", null);
//     });
// }
